import { render, staticRenderFns } from "./DegustacaoCampanha.vue?vue&type=template&id=416579da&"
import script from "./DegustacaoCampanha.vue?vue&type=script&lang=js&"
export * from "./DegustacaoCampanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports